// ./src/components/lists/ListCalled/Item/index.tsx
import React, { useState, useMemo, useCallback, useEffect } from 'react';

import { FiArrowDown, FiCornerUpRight } from 'react-icons/fi';
import {
  IoEllipsisHorizontal,
  IoCheckmarkCircleOutline,
} from 'react-icons/io5';

import { ButtonMain, InputRadio, Paragraph } from '@components/index';
import {
  ConfigRoutes,
  ConfigStyles,
  ConfigTransition,
  ConfigValues,
} from '@config/index';
import Called from '@models/Called';
import { ISelect } from '@pages/private/Called/List/typing';
import apiZapinho from '@services/apis/apiZapinho';
import { apiRebox } from '@services/index';
import {
  formatCNPJ,
  formatCPF,
  formatDate,
  formatMoney,
  formatText,
} from '@utils/formatters';
import { toastify } from '@utils/notifiers';

import {
  Container,
  CompositeItem,
  CompositeItemText,
  Dropdown,
  DropdownItem,
  AssistantsContainer,
  AssistantLabel,
} from './styles';

interface IProps {
  called: Called;
}

const ListCalledAffiliatesItem: React.FC<IProps> = ({ called }) => {
  const [called_payment_status, setCalledPaymentStatus] = useState(
    called.service_payment_status,
  );
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const requestedIn = useMemo(() => {
    const date = called.date_created;
    return formatDate.addMask(date);
  }, []);

  const serviceFor = useMemo(() => {
    const date = called.appointment_date || called.date_created;
    return formatDate.addMask(date);
  }, []);

  const confirmCalledPaid = useCallback(async () => {
    try {
      const { data: reboxCalled } = await apiRebox.put(
        `/called/payment_status/${called.id}`,
        {
          ...called,
          service_payment_status: 'PAID',
        },
      );

      setCalledPaymentStatus('PAID');
      toastify(`Confirmação de pagamento enviada`, 'success');
    } catch (error) {
      called.service_payment_status = 'PAID';

      toastify(`Houve um error ao confirmar o pagamento.`, 'error');
    }
  }, []);

  return (
    <Container
      className={
        called.status === ConfigValues.rebox.called.status.open ? 'cheerUp' : ''
      }
      onClick={() => setIsExpanded(prev => !prev)}
    >
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {requestedIn}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {serviceFor}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {called.who_is_answering?.name.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {called.who_is_answering?.cpf
          ? formatCPF.addMask(called.who_is_answering.cpf)
          : called.who_is_answering?.cnpj
          ? formatCNPJ.addMask(called.who_is_answering.cnpj)
          : ''}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {called.who_is_answering?.cellphone.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {called.service_payment_pix ?? 'Nenhuma chave cadastrada'}
      </Paragraph>

      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {called.vehicle?.license_plate.toUpperCase()}
      </Paragraph>

      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {String(called.distance_between_points_in_km).replaceAll('.', ',')} KMs
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {called?.budget_amount
          ? formatMoney.fromNumberToPrice(called.budget_amount)
          : ' - '}
      </Paragraph>

      <Paragraph
        style={{
          minWidth: 90,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          color:
            called_payment_status === 'PAID'
              ? ConfigStyles.rebox.colors.greenEmerald.main
              : ConfigStyles.rebox.colors.red.main,
        }}
        fontSize={12}
        className="btn-options"
      >
        {called_payment_status === 'PAID' ? 'Pago' : 'Aguardando'}
      </Paragraph>
      <Paragraph>
        <IoEllipsisHorizontal
          size={14}
          color={ConfigStyles.rebox.colors.black.main}
          style={{ cursor: 'pointer' }}
        />
      </Paragraph>
      <Dropdown
        expande={isExpanded}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <DropdownItem
          onClick={e => {
            e.preventDefault();
            confirmCalledPaid();
          }}
          to={`#`}
        >
          <IoCheckmarkCircleOutline
            size={16}
            title="ícone de setas"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Paguei
          </Paragraph>
        </DropdownItem>
      </Dropdown>
    </Container>
  );
};

export default ListCalledAffiliatesItem;
